import ShipperDetail from "@/classes/bookings/ShipperDetail";
import ConsigneeDetail from "@/classes/bookings/ConsigneeDetail";

export class Booking {

    constructor() {

        this.id = 0;
        this.jobNumber = '';
        this.customer = '';

        this.shipper = new ShipperDetail();
        this.consignee = new ConsigneeDetail();
        this.newShipperCompany = new ShipperDetail();
        this.isEditShipperAddress = false;
        this.newConsigneeCompany = new ConsigneeDetail();
        this.isEditConsigneeCompany = false;

        this.openShipperModal = false;
        this.openShipperContactModal = false;
        this.openConsigneeModal = false;
        this.openConsigneeContactModal = false;

        this.dimensions = {

            multiLineDims: [],
            totalPieces: '',
            totalWeight: '',
            chargeableWeight: '',
            cubeUnit:'',
            cube: ''
        }

        this.isUpdate = {

            shipper: false,
            consignee: false

        }

        this.unitOfMeasureSwitch = false,
        this.cubeUnitSwitch = false,

        this.files = [];

    }
}
